// eventHandlers.js
export const handleBeforeUnload = (event) => {
  event.preventDefault();
  event.returnValue = "";
  // Removed localStorage.clear() to allow refreshing during test
};

export const handleBackButton = (event) => {
  event.preventDefault();

  if (!window.confirm("Are you sure you want to leave this page?")) {
    window.history.pushState(null, null, window.location.pathname);
  } else {
    // Navigate to the page the user was trying to go to
    window.history.go(1);
  }
};
